var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.3951mm",
    height: "10.105mm",
    viewBox: "0 0 5.3951 10.105",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient37760",
    x1: 83.26,
    x2: 83.26,
    y1: 91.239,
    y2: 82.895,
    gradientTransform: "matrix(1 0 0 1 3.3403e-5 -.00023953)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdada4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe8e5",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82.358 -82.041)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#linearGradient37760)",
    stroke: "#ef2118",
    strokeLinejoin: "round",
    strokeWidth: 1.765,
    "aria-label": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83.24 82.923v1.7357h1.7145v6.604h1.9156v-8.3396z",
    strokeLinecap: "square",
    style: {
      paintOrder: "stroke markers fill"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.5b6e5ceae017be68bde2d20e2b1f6207.svg";
export { ForwardRef as ReactComponent };